import _ from 'underscore';
import { getAssetSharingHtml } from './utils/social-media-sharing';
import * as SwatchbookUtils from './modules/swatchbook-utils';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

// Swatch and photo image item templates
const swatchTemplate =
  `<div id="{{ id }}" class="swatch{{ (newSwatch === true ? ' new-swatch' : '') }}">
    <div notranslate="" class="image-wrapper swatch-image teaser lazyloaded" data-modal-label="Detail for swatch number {{ colorNumber }}, {{ colorName }}" data-props="Image,,,," data-meta-description="" data-product-description="" data-product-url="" data-image-story="<table width='100%'>{{ modalData }}</table>" data-image-url="{{ imageUrl }}" data-product-line-id="" id="modal-item-0">
      <span class="gallery-link swatch-link" data-toggle="modal" data-target="#modal-0">
        <img class="scale a6T poster-image lazyload" src="/assets/dist/images/blank.gif" notranslate="" alt="{{ collection }} - {{ colorName }} - {{ colorNumber }}" data-src="{{ imageUrl }}">
        <button class="swatchcard--viewdetail">View <span class="sr-only">Swatch </span>Detail</button>
      </span>
    </div>
    <div class="swatchcard--content">
      <ul class="list-unstyled swatch-info-list">
        <li class="swatch-info-item" notranslate="">{{ colorName }}</li>
        <li class="swatch-info-item" notranslate="">{{ colorNumber }} <span class="cart-item-filters"><span> &bull; {{ collection }}</span><span> &bull; {{ productLine }}</span><span> &bull; {{ swatchCatName }}</span>{{ (displayMessage !== '' ? '<br><span class="display-message">' + displayMessage + 'gulp</span>' : '') }}</span></li>
      </ul>
      <button class="swatchbutton" data-collection="{{ collection }}" data-colorName="{{ colorName }}" data-colorNumber="{{ colorNumber }}" data-id="{{ id }}" data-imageUrl="{{ imageUrl }}" data-productLine="{{ productLine }}" data-styleId="{{ styleId }}" data-swatchCatId="{{ swatchCatId }}" data-swatchCatName="{{ jsSafeSwatchCatName }}" data-swatchStyleName="{{ jsSafeSwatchStyleName }}" data-swatchId="{{ swatchId }}" data-newSwatch="{{ newSwatch }}" data-display-message="{{ displayMessage }}" data-type="{{ type }}">
        <span>
          <div class="swatchbutton--icon">
            <div class="icon"></div>
          </div>
          <div class="swatchbutton--label">Add Swatch</div>
        </span>
      </button>
    </div>
  </div>`;

const photoTemplate =
  `<li class="gallery-item gallery-item--image" id="image-{{ id }}">
    <div>
      <button type="button" class="gallery-modal-toggle" id="{{ id }}" aria-expanded="false" aria-controls="modal-{{ id }}" aria-label="View Details for saved photo number {{ index }}">
        <img src="{{ imageUrl }}" alt="{{ imageAlt }}" aria-hidden="true" />
      </button>
    </div>
  </li>`;

const noSwatchesTemplate =
  `<div class="swatchbook-no-content">
    <div>
      Browse through a wide variety of swatches to find Bali window treatments that match your style
      <br /><br />
    </div>
    <a href="/swatches/" class="btn btn-secondary">Browse Swatches</a>
  </div>`;

const noPhotosTemplate =
  `<div class="swatchbook-no-content">
    <div>
      Find inspiration throughout a collection of inspired window treatment settings curated by the Bali design team
      <br /><br />
    </div>
    <a href="/inspiration/photo-video-gallery/" class="btn btn-secondary">View Photo & Video Gallery</a>
  </div>`;

const photoModalTemplate =
  `<div class="modal fade show" id="modal-{{ id }}" tabindex="-1" role="dialog" aria-labelledby="modal-label-{{ id }}">
    <div class="modal-dialog modal-dialog-centered mx-auto" role="document">
      <div class="container">
        <div class="modal-content">
          <div class="row row-eq-height">
            <div class="col-12 col-sm-12 col-md-8 col-lg-9">
              <div class="modal-image">
                <img src="{{ imageUrl }}" alt="{{ imageAlt }}" />
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-3">
              <div class="modal-description d-flex flex-column justify-content-center">
                <button type="button" class="btn-close btn-close-white" aria-label="Close Modal"></button>
                <h2 class="heading-sm modal-title" id="modal-label-undefined">{{ productLineName }}</h2>
                <div class="image-caption m-b-lg">
                  <p class="mb-0">{{ description }}</p>
                  <p>
                    <a href={{ productLineUrl }}><span class="link-underline">Learn More</span><span class="sr-only"> About {{ productLineName }}</span> &rarr;</a>
                  </p>
                </div>
                <div class="btns d-flex gap-xxs justify-content-between align-items-start flex-row flex-wrap mb-4 align-items-center m-b-xl">
                  <a class="btn btn-secondary mb-2" href="/swatches?product-line-id={{ productLineId }}"><span class="link-underline">Order Swatches</span></a>
                  <div class="social-media-sharing"></div>
                </div>
                <div class="favorites-item-btn-wrapper">
                  <button class="favorites-item-btn update-swatchbook-btn btn btn-secondary rounded-0" data-asset-id="{{ id }}">
                    <span>
                      <div class="remove-item-btn-icon">
                        <div class="icon"></div>
                      </div>
                      <div class="favorites-item-btn-label">Remove from My Favorites</div>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const videoModalTemplate =
  `<div class="modal fade" id="modal-{{ id }}" role="dialog" aria-labelledby="modal-label-{{ id }}">
    <div class="container">
      <button type="button" class="btn-close"></button>
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="row row-eq-height">
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-9">
              <div class="modal-video">
                <iframe id="modal-iframe" class="modal-iframe" src="{{ videoUrl }}/?rel=0" title="{{ title }}" allowfullscreen=""></iframe>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
              <div class="modal-description">
                <h4 class="modal-title" id="modal-label-undefined">{{ title }}</h4>
                <div class="video-description">
                  <p>{{ description }}</p>
                </div>
                <button id="{{ id }}" class="action-link white border-black update-swatchbook-btn"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const swatchTemplateVals = _.template(swatchTemplate);
const photoTemplateVals = _.template(photoTemplate);
const photoModalTemplateVals = _.template(photoModalTemplate);
const videoModalTemplateVals = _.template(videoModalTemplate);
const selector = document.querySelector('.photo-modal-container');

// Store data in here for management of swatchbook inside swatchbook
let localSwatchbook = [];

const updateSwatchbook = () => {
  // Show print/download buttons only if there's content
  if (localSwatchbook.items.length === 0) {
    document.querySelector('.action-link--download-pdf').classList.add('hidden');
    document.querySelector('.action-link--print').classList.add('hidden');
  } else {
    document.querySelector('.action-link--download-pdf').classList.remove('hidden');
    document.querySelector('.action-link--print').classList.remove('hidden');
  }
  // Show place order button only if there's swatch content
  if (SwatchbookUtils.getAllOfType('swatch').length === 0) {
    document.querySelector('.action-link--place-order').classList.add('hidden');
  } else {
    document.querySelector('.action-link--place-order').classList.remove('hidden');
  }
};

const encodeHtmlEntities = (data) => {
  const clean = data.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  return clean;
};

const buildSwatchbook = () => {
  const swatchData = SwatchbookUtils.getAllOfType('swatch');
  const photoData = SwatchbookUtils.getAllOfType('photo');
  const swatchSelector = document.querySelector('.swatchgrid-inner');
  const photoSelector = document.querySelector('.photogrid-inner');
  let compiled = null;
  let d = null;
  // Swatches
  if (swatchData.length === 0) {
    d = document.createElement('div');
    d.innerHTML = noSwatchesTemplate;
    swatchSelector.appendChild(d.firstChild);
  } else {
    swatchData.forEach((item) => {
      item.modalData = SwatchbookUtils.decodeSwatchModalTableDataById(item.modalData);
      item.jsSafeSwatchStyleName = encodeHtmlEntities(item.swatchStyleName);
      item.jsSafeSwatchCatName = encodeHtmlEntities(item.swatchCatName);
      item.newSwatch = (item.newSwatch) ? item.newSwatch : 'N'; // Fix for previously saved swatches
      item.displayMessage = (item.displayMessage) ? item.displayMessage : ''; // Fix for previously saved swatches
      compiled = swatchTemplateVals(item);
      d = document.createElement('div');
      d.innerHTML = compiled;
      swatchSelector.appendChild(d.firstChild);
    });
  }
  // Photos
  if (photoData.length === 0) {
    d = document.createElement('div');
    d.innerHTML = noPhotosTemplate;
    photoSelector.appendChild(d.firstChild);
  } else {
    photoData.forEach((item, index) => {
      item.index = index + 1;
      compiled = photoTemplateVals(item);
      d = document.createElement('div');
      d.innerHTML = compiled;
      photoSelector.appendChild(d.firstChild);
    });
  }
};

const getLocalItemById = (id) => {
  const item = localSwatchbook.items.find(saved => saved.id === id);
  if (item !== undefined) {
    return item;
  }
  return null;
};

const resetGalleryFocus = () => {
  const btn = document.querySelector('.media-gallery-list [aria-expanded="true"]');
  if (btn) {
    btn.setAttribute('aria-expanded', 'false');
    btn.focus();
  }
};

const updateSwatchbookButton = (event) => {
  const { target } = event;
  const { nodeName } = target;
  let btn = target;
  if (nodeName !== 'BUTTON') {
    btn = btn.closest('.update-swatchbook-btn');
  }
  const id = btn.getAttribute('data-asset-id');
  if (SwatchbookUtils.getItemById(id) !== null) {
    // Remove item from local storage
    SwatchbookUtils.removeSwatchbookItem({
      type: 'photo',
      value: id,
    });
    // Remove modal
    selector.querySelector('.update-swatchbook-btn').removeEventListener('click', updateSwatchbookButton);
    selector.removeChild(selector.firstChild);
    document.removeEventListener('click', removeGalleryModal); /* eslint-disable-line no-use-before-define */
    resetGalleryFocus();
    // Remove item from photos section in My Favorites
    const gridItem = document.getElementById(`image-${id}`);
    gridItem.remove();
    // Check if zero photos in local storate
    const photoData = SwatchbookUtils.getAllOfType('photo');
    const photoSelector = document.querySelector('.photogrid-inner');
    if (photoData.length === 0) {
      const d = document.createElement('div');
      d.innerHTML = noPhotosTemplate;
      photoSelector.appendChild(d.firstChild);
    }
  }
};

const removeGalleryModal = (event) => {
  // Is modal open when event listener fired
  if (selector.firstChild !== null) {
    if (event.target.classList.contains('modal') && event.target.classList.contains('show')) {
      selector.querySelector('.update-swatchbook-btn').removeEventListener('click', updateSwatchbookButton);
      selector.removeChild(selector.firstChild);
      document.removeEventListener('click', removeGalleryModal);
      resetGalleryFocus();
    } else if (event.target.classList.contains('btn-close')) {
      selector.querySelector('.update-swatchbook-btn').removeEventListener('click', updateSwatchbookButton);
      selector.removeChild(selector.firstChild);
      document.removeEventListener('click', removeGalleryModal);
      resetGalleryFocus();
    }
  }
};

const modalEventHandlers = () => {
  document.addEventListener('click', removeGalleryModal);
  selector.querySelector('.update-swatchbook-btn').addEventListener('click', updateSwatchbookButton);
};

const addGalleryModal = (event) => {
  const { target } = event;
  const { nodeName, parentElement } = target;
  const { PhotoShareUrl, location } = window;
  const { origin } = location;
  let btn = target;
  if (nodeName !== 'BUTTON') {
    btn = parentElement;
  }
  const { id } = btn;
  const item = getLocalItemById(id);
  // Add missing properties to item
  item.shareLink = encodeURIComponent(`${origin}${PhotoShareUrl}#${id}`);
  item.src = item.imageUrl;
  const d = document.createElement('div');
  let compiled = '';
  if (item.videoUrl !== undefined) {
    compiled = videoModalTemplateVals(item);
  } else {
    compiled = photoModalTemplateVals(item);
  }
  d.innerHTML = compiled;
  selector.appendChild(d.firstChild);
  // Set focus to modal close
  document.querySelector('.modal .btn-close').focus();
  // Add social media shares
  const socialMediaSharingWrapper = selector.querySelector('.social-media-sharing');
  socialMediaSharingWrapper.innerHTML = getAssetSharingHtml(item);
  // Add modal handlers
  modalEventHandlers();
};

// Initialize
const init = () => {
  SwatchbookUtils.init();
  localSwatchbook = SwatchbookUtils.getSwatchbookData();
  updateSwatchbook();
  // Init pdfUtils
  const { pdfUtils } = window;
  pdfUtils.data = JSON.parse(window.localStorage.getItem('bali_swbk'));
  if (pdfUtils.data === null) {
    // Set up an empty data object
    pdfUtils.data = { items: [], cart: [] };
  }
  buildSwatchbook();
  // Add modal handler
  if (document.querySelectorAll('.gallery-modal-toggle')) {
    [].map.call(document.querySelectorAll('.gallery-modal-toggle'), btn => btn.addEventListener('click', (event) => {
      btn.setAttribute('aria-expanded', 'true');
      addGalleryModal(event);
    }));
  }
  // Clear Swatchbook
  document.querySelector('.action-link--clear-favorites').addEventListener('click', () => {
    if (window.confirm(window.clearSwatchbookWarningMessage)) {
      window.localStorage.removeItem('bali_swbk');
      window.location.reload(true);
    }
  });
};

export default {
  init,
};

if (document.querySelector('.swatchbook-app')) {
  init();
}
